// extracted by mini-css-extract-plugin
export default {"list":"BookList_list__USQbW"};